<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card-title>
                  <v-text-field
                      @input="search"
                      append-icon="mdi-magnify"
                      label="Szukaj telefonu"
                      single-line
                      hide-details
                  ></v-text-field>
                </v-card-title>
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="views"
                        :options.sync="options"
                        :server-items-length="totalViews"
                        :loading="loading"
                        class="elevation-1"
                        :item-class="itemRowBackground"
                >
                    <template v-slot:item.createdAt="{ item }">
                        {{ localDateTime(item.createdAtDto) }}
                    </template>
                    <template v-slot:item.createdAtDto="{ item }">
                      <v-menu
                          bottom
                          left
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              color="primary"
                              icon
                              v-bind="attrs"
                              v-on="on"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item v-if="item.url" v-bind:href="item.url" target="_blank">
                            <v-list-item-title>Mam odpad</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.mapsUrl" v-bind:href="item.mapsUrl" target="_blank">
                            <v-list-item-title>Mapy Google</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import debounce from 'debounce';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
    import permissions from '@/mixins/permissions';

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                modal: false,
                menu1: false,
                menu2: false,
                menu3: false,
                totalViews: 0,
                views: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'Telefon', value: 'phone', sortable: false, filterable: true, },
                    { text: 'Firma', value: 'company.name', sortable: false, filterable: true, },
                    { text: 'Kategoria', value: 'category', sortable: false, filterable: false, },
                    { text: 'Miasto', value: 'city', sortable: false, filterable: false, },
                    { text: 'Data wyświetlenia', value: 'createdAt', sortable: false, filterable: false, },
                    { text: 'Linki', value: 'createdAtDto', sortable: false, filterable: false, },
                ],
            }
        },
        watch: {
            options: {
                handler () {
                    this.getViews();
                    setDatatableOptions.call(this);
                },
                deep: true,
            },
        },
        methods: {
            search(value) {
              if (value.length > 2) {
                this.getViews(value);
              } else if (value.length === 0) {
                this.getViews();
              }
            },
            async getViews(phone) {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (phone) {
                    params.phone = phone;
                }

                const response = await api.get('/api/partner-content/phone-view', {params});
                this.loading = false;

                this.views = response.data.items;
                this.totalViews = response.data.total;
            },
            itemRowBackground: function (item) {
              const now = Date.now();
              const subDates = (now/1000 - item.createdAtDto.timestamp) / 60;

              let className = '';

              if (subDates < 1) {
                className = 'newest';
              } else if (subDates < 3) {
                className = 'newer';
              } else if (subDates < 10) {
                className = 'new';
              }

              return className
            },
            initEventStream: function () {
              let domain = process.env.VUE_APP_API_URL;
              let port = ':8800'
              const domainParts = domain.split(':');
              domain = domainParts[0] + ':' + domainParts[1];

              if (domain.endsWith('.pl')) {
                // On remote servers we need to communicate over HTTPS to avoid security issues.
                // It is also important to use standard port to avoid SSL errors.
                domain = domain.replace(/api\./, 'sse.')
                port = ''
              }

              document.cookie = "mercureAuthorization=" +
                  localStorage.mercureToken +
                  "; expires=0; path=/; domain=" +
                  domain
                      .replace('sse', '')
                      .replace('https://', '')
                      .replace('http://', '')+
                  port;

              const url = new URL(`${domain}${port}/.well-known/mercure`);
              url.searchParams.append('topic', localStorage.mercureTopic);

              const source = new EventSource(url.toString(), {
                withCredentials: true
              })
              source.onmessage = event => {
                const data = JSON.parse(event.data);
                if (data.data.type === 'partner.phone_view') {
                  this.search = '';
                  this.getViews();
                }

              };
            },
        },
        created() {
            getDatatableParams.call(this);
            debounce(function () {
                this.getViews();
            }, 500);
            this.initEventStream();
        }
    }
</script>

<style lang="scss">
  .newest {
    background-color: #FF0033FF !important;
    color: #ffffff !important;
    :hover {
      background-color: #FF0033FF;
      color: #000000;
    }
  }
  .newer {
    background-color: #ff8c00 !important;
    color: #000000 !important;
    :hover {
      background-color: #ff8c00;
      color: #ffffff;
    }
  }
  .new {
    background-color: #fff300 !important;
    color: #000000 !important;
    :hover {
      background-color: #fff300;
      color: #ffffff;
    }
  }
</style>